/**
 * Betting data matcher library module.
 * Used for fetching event and/or participant content from betting data matcher service.
 */

import config from '@/config'

const dataMatcherHostname = config.app.autoconf.BETTING_DATA_MATCHER_SERVICE_HOSTNAME

/**
 * @param {Object} payload
 * @param {any} payload.idFoEvent - mandatory
 * @param {string} payload.dataSource - optional
 * @param {string} payload.contentType - optional
 */
// For more information, check betting data matcher service docs.
async function fetchEventContent (payload) {
  if (!payload.idFoEvent) throw new Error('Missing required parameter - "idFoEvent"')
  const url = `${dataMatcherHostname}/bettingMatcher/api/v1/eventContent`
  const params = new URLSearchParams(payload)
  try {
    const response = await fetch(`${url}?${params}`)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error(`fetchEventContent error: ${error}`)
  }
}

/**
 * @param {Object} payload
 * @param {any} payload.idFoEvent - mandatory
 * @param {string} payload.dataSource - optional
 * @param {string} payload.contentType - optional
 */
// For more information, check betting data matcher service docs.
async function fetchParticipantContent (payload) {
  if (!payload.idFoEvent) throw new Error('Missing required parameter - "idFoEvent"')
  const url = `${dataMatcherHostname}/bettingMatcher/api/v1/participantContent`
  const params = new URLSearchParams(payload)
  try {
    const response = await fetch(`${url}?${params}`)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error(`fetchParticipantContent error: ${error}`)
  }
}

export default {
  fetchEventContent,
  fetchParticipantContent
}



// WEBPACK FOOTER //
// ./src/library/bettingDataMatcher/index.js